export default "__VITE_ASSET__DMNnJHjR__"